module.exports = __webpack_public_path__ + "static/media/light-theme-overspeed-duration.d31e17a7.svg";